<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { imagePanelInstrument } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div v-if="imagePanelInstrument.display" class="col-span-12 lg:col-span-6">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ imagePanelInstrument.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsList
          v-if="imagePanelInstrument.displayList"
          :elements="details.imagePanelInstrument.list"
          :element-class="
            imagePanelInstrument.renderInTwoColumns ? 'w-1/2' : ''
          "
          class="mb-3"
          :class="{
            'flex flex-wrap': imagePanelInstrument.renderInTwoColumns,
          }"
        />

        <SectionsDetailsElementsImages
          v-if="imagePanelInstrument.displayImages"
          :images="details.imagePanelInstrument.images"
          class="xl:!grid-cols-5"
        />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
